module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-regular-straight-E4NUVXFC.eot?bf256b6f8c57c1c04ead7e992d357e00";